export default __webpack_public_path__ + "static/upper3_2-1266718993b476014296595ca1aa01c5.jpg";